import { DeviceInfoProps } from "../../util/devices-info";
import {
  SET_DEVICE_INFO,
  FETCH_DEVICE_SYSTEM_ID_REQUEST,
  FETCH_DEVICE_SYSTEM_ID_SUCCESS,
  FETCH_DEVICE_SYSTEM_ID_FAILURE,
} from "./actions.type";
import { SetDeviceInfo, FetchSystemIDRequest, FetchSystemIDSuccess, FetchSystemIDFailure } from "./types";

export const setDeviceInfo = (payload: DeviceInfoProps): SetDeviceInfo => ({
  type: SET_DEVICE_INFO,
  payload,
});

export const fetchSystemIDRequest = (): FetchSystemIDRequest => ({
  type: FETCH_DEVICE_SYSTEM_ID_REQUEST,
});

export const fetchSystemIDSuccess = (payload: DeviceInfoProps): FetchSystemIDSuccess => ({
  type: FETCH_DEVICE_SYSTEM_ID_SUCCESS,
  payload,
});

export const fetchSystemIDFailure = (error?: string): FetchSystemIDFailure => ({
  type: FETCH_DEVICE_SYSTEM_ID_FAILURE,
  error,
});
